// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"8053e06c","243":"60caca49","415":"deb0dfa3","449":"77a0d455","513":"bbbe12bc","874":"3c794a71"}[chunkId] + ".chunk.js";
};